import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "utils/config";

export const getPaymentLink = async (loan_id: string, amount: number, agentCode?: string): Promise<{url: string}> => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: "/kuber/payment-link",
    params: {
      loan_id,
      amount,
      ...(agentCode? {agentCode} : {})
    },
    method: "get",
  });
  return res.data;
}